/* tslint:disable */
/* eslint-disable */
/**
 * LTCS gateway API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferPropertiesInner
 */
export interface OfferPropertiesInner {
  /**
   * 
   * @type {string}
   * @memberof OfferPropertiesInner
   */
  identifier?: string;
  /**
   * 
   * @type {string}
   * @memberof OfferPropertiesInner
   */
  name?: string;
  /**
   * 
   * @type {string}
   * @memberof OfferPropertiesInner
   */
  description?: string;
  /**
   * 
   * @type {string}
   * @memberof OfferPropertiesInner
   */
  legalDescription?: string;
  /**
   * 
   * @type {string}
   * @memberof OfferPropertiesInner
   */
  value?: string;
  /**
   * 
   * @type {Array<string>}
   * @memberof OfferPropertiesInner
   */

  translatedValue?: string;
  /**
   * 
   * @type {Array<string>}
   * @memberof OfferPropertiesInner
   */
  tags?: Array<string>;
  /**
   * 
   * @type {number}
   * @memberof OfferPropertiesInner
   */
  price?: number | null;
}

/**
 * Check if a given object implements the OfferPropertiesInner interface.
 */
export function instanceOfOfferPropertiesInner(value: object): boolean {
  let isInstance = true;

  return isInstance;
}

export function OfferPropertiesInnerFromJSON(json: any): OfferPropertiesInner {
  return OfferPropertiesInnerFromJSONTyped(json, false);
}

export function OfferPropertiesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferPropertiesInner {
  if ((json === undefined) || (json === null)) {
    return json;
  }

  return {

    'name': !exists(json, 'name') ? undefined : json['name'],
    'identifier': !exists(json, 'identifier') ? undefined : json['identifier'],
    'description': !exists(json, 'description') ? undefined : json['description'],
    'legalDescription': !exists(json, 'legal_description') ? undefined : json['legal_description'],
    'value': !exists(json, 'value') ? undefined : json['value'],
    'translatedValue': !exists(json, 'translated_value') ? undefined : json['translated_value'],
    'tags': !exists(json, 'tags') ? undefined : json['tags'],
    'price': !exists(json, 'price') ? undefined : json['price'],
  };
}

export function OfferPropertiesInnerToJSON(value?: OfferPropertiesInner | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {

    'name': value.name,
    'identifier': value.identifier,
    'description': value.description,
    'legal_description': value.legalDescription,
    'value': value.value,
    'tags': value.tags,
    'price': value.price,
  };
}

